import SignOut from "./SignOutContainer";

export default SignOut;
